/**
 * Converts boolean disabled state to proper Gux component format
 * @param disabled - The disabled state
 * @returns true if disabled, undefined if enabled (for accessibility)
 */
export const toGuxDisabled = (disabled: boolean | undefined | null) => {
    return disabled ? true : undefined;
};
